window.addEventListener('load', () => {
  const navLinks = document.querySelectorAll('.card-list__nav-link');

  navLinks.forEach((link) => {
    const linkId = link.getAttribute('href');

    if (linkId && linkId !== '#') {
      const sectionElem = document.querySelector(linkId);

      if (sectionElem) {
        gsap.timeline({
          scrollTrigger: {
            trigger: sectionElem,
            start: 'top center',
            end: 'bottom center',
            scrub: true,
            toggleClass: { targets: link, className: 'is-active' },
          },
        });
      }
    }
  });
});
